import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  useListContext,
  Datagrid,
  NumberField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR } from '../../utils/dadosTelas';
import Dialogo from './DialogoCreateEdit';
//import ActionsField from './Fields/ActionsField';
import Filter from './Filter';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refresh = useRefresh();
  const listContext = useListContext();
  const classes = useStyles();
  const { filterValues } = listContext;

  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Estados Brasileiros" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextoField
            source="nome"
            label="Nome"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextoField
            source="sigla"
            label="Sigla"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <NumberField
            source="icms_ai_compra"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }}
            label="ICMS Alíquota Interna de Compra (%)"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            /* handleEdit={handleEdit}
            ativo={filterValues.ativo} */
            actions={[
              {
                key: 'edit',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (record) => handleEdit(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Estados Brasileiros"
      sort={{ field: 'nome', order: 'asc' }}
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
